import React, { useEffect, useState } from "react";
import CreatePublishActivity from "../../../../Create_Assessment_Activity/create_published/CreatePublishActivity";
import PdfQTypeDRaft from "../../../Draft/Draft_Assess_Box/Draft_Q_list/PdfQTypeDRaft";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import axios from "../../../../../../axios";
// css comes from draft_Q_list_Activity.css

const EditPublishedActivity = () => {
  const navigate = useNavigate();
  const [click, setClick] = useState(false);
  const { EditPublishedActivity_id } = useParams();
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);

  const [updateActivity, setUpdateActivity] = useState({
    description: "",
    updateTittle: "",
    updateTotalMarks: "",
    updateDeadline: "",
    updateScheduleDate: "",
    updateScheduleTime: "",
    attach: [],
  });
  const {
    description,
    updateTittle,
    updateTotalMarks,
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
    attach,
  } = updateActivity;

  const [published, setPublished] = useState({
    publishedActivitys: [],
  });
  const { publishedActivitys } = published;

  useEffect(() => {
    const getDraftActivity = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/activity/getById/${EditPublishedActivity_id}`
        );
        res &&
          setPublished({
            publishedActivitys: res.data.data,
          });
        setUpdateActivity({
          ...updateActivity,
          description: res?.data.data.description,
          updateTittle: res?.data.data.name,
          updateTotalMarks: res?.data.data.total_marks,
          attach: res?.data.data.attachments,
          updateDeadline: res?.data.data.deadline,
          updateScheduleDate: res?.data.data.schedule_date,
          updateScheduleTime: res?.data.data.schedule_time,
        });
      } catch (error) { }
    };
    getDraftActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handelDraft = async () => {
  let createActivityDraft = {
    standard_id: publishedActivitys?.standard_id?.id,
    subject_id: publishedActivitys?.subject_id?.id,
    section_id: publishedActivitys?.section_id?.id,
    book_id: publishedActivitys?.book_id?.id,
    chapter_id: publishedActivitys?.chapter_id?.id,
    teacher_id: Teacher_Json,
    status: "draft",
    description: description,
    name: updateTittle,
    total_marks: updateTotalMarks,
    attachments: attach,

    // attach,
    difficulty_level: publishedActivitys?.difficulty_level?.id,
    deadline: updateDeadline,
    schedule_date: updateScheduleDate,
    schedule_time: updateScheduleTime,
  };

  const myFileInput = document.getElementById("attachFile");
  myFileInput?.addEventListener("change", (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("uploadActivityAttachment", file);
    axios
      .post(
        `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
        formData
      )
      .then((response) => {
        createActivityDraft.attachments = response.data.data;
        setUpdateActivity({
          ...updateActivity,
          attach: [response.data.data],
        });
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  });

  const helper = async () => {
    try {
      let res = await axios.post(
        `/api/v1/homework/activity/update/${publishedActivitys.id}`,
        createActivityDraft
      );

      navigate("/PublishedHomeworkActivity");
    } catch (error) {
      console.log(error);
    }
  };

  const isDisableDraft =
    updateActivity.updateTittle === "" || updateActivity.description === "";
  const isDisablePublish =
    updateActivity.updateTotalMarks === "" ||
    updateActivity.updateTittle === "" ||
    updateActivity.description === "";

  const titleRejex = /^\s+/;
  const descriptionRejex = /^\s+/;

  const errors = {};
  if (updateTittle === (titleRejex.test(updateTittle) && updateTittle)) {
    errors.updateTittle = "Tittle can not start with a space";
  }
  if (description === (descriptionRejex.test(description) && description)) {
    errors.description = "Description can not start with a space";
  }

  return publishedActivitys ? (
    <>
      <div>
        <div>
          <div className="d-flex align-items-center ">
            <Link to="/PublishedHomeworkActivity" className="link">
              <img src="/images/Back Arrow.svg" alt=""></img>
            </Link>
            <Link to="/PublishedHomeworkActivity" className="link">
              <span className="open_draft_path">
                &nbsp; {publishedActivitys?.status} /&nbsp;
              </span>
            </Link>

            <span className="open_draft_path">
              {publishedActivitys?.name} /
            </span>
            <span className="mt-1 open_draft_path1">
              edit {publishedActivitys?.name}
            </span>
          </div>
          <div className="mt-2 publishsub_heading">
            {publishedActivitys?.name}
          </div>

          <div className="p-0 col-11">
            <div className="d-flex align-items-center justify-content-between">
              <div className="sub_heading_activityDraft">
                Create fun activity for the students here.
              </div>
              <input
                id="addMarks"
                value={updateTotalMarks}
                type="text"
                class="form-control  txt_draft3"
                placeholder="Add Marks"
                onChange={(e) =>
                  setUpdateActivity({
                    ...updateActivity,
                    updateTotalMarks: e.target.value,
                  })
                }
              />
            </div>

            <div className="ms-5">
              <input
                type="text"
                value={updateTittle}
                placeholder="Enter title"
                class="txt_draft1 mt-3 form-control"
                id="txt-i-first"
                onChange={(e) =>
                  setUpdateActivity({
                    ...updateActivity,
                    updateTittle: e.target.value,
                  })
                }
              />
              {errors.updateTittle && (
                <span className="error">{errors.updateTittle}</span>
              )}

              <Form.Control
                as="textarea"
                placeholder="Enter Description"
                value={description}
                rows={4}
                className="px-3 py-2 mt-4 txt_draft2"
                onChange={(e) =>
                  setUpdateActivity({
                    ...updateActivity,
                    description: e.target.value,
                  })
                }
              />
              {errors.description && (
                <span className="error">{errors.description}</span>
              )}

              <div>
                <div>
                  <button className="px-3  pt-2 mt-2 d-flex align-items-center justify-content-center activity_draft_attach ">
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      id="attachFile"
                      style={{ display: "none" }}
                      // onChange={(e) => setPublushedAttact(e.target.files[0])}
                      onChange={(e) =>
                        setUpdateActivity({
                          ...updateActivity,
                          attach: e.target.files[0],
                        })
                      }
                    />
                    <label
                      className="d-flex align-items-center justify-content-center "
                      htmlFor="attachFile"
                    >
                      <img alt="" src="/images/Attach.svg" />

                      <span>&nbsp;Attach</span>
                    </label>
                  </button>
                </div>
              </div>
              <div className="mt-2 p-1 pdf_draft_activity d-flex">
                {attach && attach[0]?.length !== 0 && (
                  <PdfQTypeDRaft
                    setDraftAttach={setUpdateActivity}
                    updateActivity={updateActivity}
                    editAttachData={publishedActivitys}
                    attach={attach}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="me-4 mt-3 d-grid gap-2 d-md-flex justify-content-md-end">
            <button
              className="btn px-3  py-2 Next_button_draftAct"
              type="button"
              // onClick={handelDraft}
              onClick={() => {
                helper();
              }}
              disabled={isDisableDraft}
            >
              Save as Draft
            </button>
            {/* <button
              className="btn  px-5  py-2 Next_button_publicAct"
              onClick={(e) => setClick(true)}
            >
              Next
            </button> */}
            <button
              className="btn  px-5  py-2 Next_button_publicAct"
              onClick={(e) => setClick(true)}
              disabled={isDisablePublish}
            >
              Publish
            </button>
          </div>
        </div>

        {click && (
          <CreatePublishActivity
            change={setClick}
            createpublishActi={publishedActivitys}
            updateActivity={updateActivity}
          />
        )}
      </div>
    </>
  ) : (
    <></>
  );
};

export default EditPublishedActivity;
